import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAllDrivers = (token, restaurant) => {
  // portalapi/api/MyMenu/Drivers?restaurantId=&organizationId= - GET
  // "https://portaldapi.unrealsoft.bg/api/
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "mymenu/drivers?restaurantid=" +
    restaurant +
    "&organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getOrdersInfoByDrivers = (
  token,
  driversIds,
  startDate,
  endDate,
  selectedRestaurant
) => {
  // https://portaldapi.unrealsoft.bg/api/statistics/delivery/turnover?driversId=1&startDate=2023-11-23&endDate=2023-11-23&organizationId=1
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "statistics/delivery/turnover?DriversIds=" +
    driversIds.join("&DriversIds=") +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate +
    "&restaurantId=" +
    selectedRestaurant +
    "&organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getAllDrivers, getOrdersInfoByDrivers };
